import React from "react";

export default function Certification() {
  return <div>Certification</div>;
}
